import { defineMessages } from 'react-intl';

export const EcoLabelCardMessages = defineMessages({
  DialogHeadline: {
    defaultMessage: 'Nachhaltigkeit',
    id: 'ecoLabelList.dialog.headline',
  },
});
